<template>
  <div>
    <commBanner :obj="obj"></commBanner>
    <titleHead :headTitle="headTitle"></titleHead>
    <div class="w80 mb-100">
      <div class="mt-30">
        <div class="news_item_nav">
          <ul>
            <li
              :class="current == index ? 'active' : ''"
              v-for="(item, index) in dictList.children"
              :key="index"
              @click="navChange(index)"
              @mouseenter="mouseover(index,item)"
              @mouseleave="mouseLeave(item)"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
		<!--技术內容-->
      <!--  <div class="strip fsc mt-20">
          <p>{{ dictLists.name }} ：</p>
          <p
            class="ml-30"
            :class="currents == index ? 'actives' : ''"
            v-for="(item, index) in dictLists.children"
            :key="index"
            @click="navsChange(index)"
          >
            {{ item.name }}
          </p>
        </div> -->
        <div class="mt-30 active_bater" >
          <div
            class="cont_list"
            v-for="(item, index) in activityList"
            :key="index"
            @click="toDetail(item)"
          >
            <div class="cont_midel">
          <div class="cont_midel_img">
            <img :src="item.cover.split(',')[0]" alt="" />
          </div>
              <div class="midel_fetr"></div>
            </div>
            <div class="mt-10">
              <p class="midel_title">
                {{ item.title }}
              </p>
              <p class="midel_text">
                <span>{{ item.position }}</span>
                <span class="ml-20">{{
                  item.createtime.substring(0, 10)
                }}</span>
              </p>
            </div>
          </div>
        </div>
          <!--分页-->
          <Pagination
            v-show="total > 0"
            :total="total"
            :page.sync="listQuery.curPage"
            :limit.sync="listQuery.limit"
            @pageChange="pageChange"
          ></Pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { getDictList, getActivityJiCaiList } from "@/api/information";
import { routerGoNewpage } from "@/utils/index";
import commBanner from "../../common/commBanner";
import titleHead from "../../common/titleHead";
import Pagination from "../../components/Pagination";
export default {
  components: { commBanner, titleHead,Pagination },
  data() {
    return {
      headTitle: "集采活动",
      obj: {
        title: "集采活动",
        isShow: false,
        isActive: false,
        roleType:'',
        personalType:7,
        companytype:''
      },
      category: 0,
      current: 0,
      currents: 0,

      totalCount: 0,
      dictList: [],
      dictLists: [],
      activityList: [],
      total: 0,
      listQuery: {
        curPage: 1,
        limit: 6,
      },
    };
  },
  created() {
    this.getDictList("industry_type");
    this.getDictList("technology_type");
    this.getMate();
    if(this.$store.state.user.userInfo){
     let type = this.$store.state.user.userInfo.type;
     this.obj.roleType = type;
    }

  },
  methods: {
    //获取集采活动列表
    getActivityJiCaiList() {
      getActivityJiCaiList({
        ...this.listQuery,
	    	type:0,
        category: this.category,
      }).then((res) => {
        if(res.code == 0){
         this.activityList = res.page.list;
         this.total = res.page.totalCount;
        }
      });
    },
    //获取分类别
    getDictList(params) {
      getDictList({ code: params }).then((res) => {
        const { data } = res;
        if (params == "industry_type") {
          this.dictList = data[0];
          this.category = this.dictList.children[0].id;
          this.getActivityJiCaiList();
        }
        if (params == "technology_type") {
          this.dictLists = data[0];
        }
      });
    },
    //详情
    toDetail(item) {
      routerGoNewpage('/jicai_activity_detail',{id: item.id });
    },
    navChange(index) {
      this.current = index;
      this.category = this.dictList.children[this.current].id;
      this.getActivityJiCaiList();
    },
	//切换内容
    navsChange(index) {
      this.currents = index;
      this.category = this.dictLists.children[this.currents].id;
      this.getActivityJiCaiList();
    },
    //移入移出
    mouseover(index,data){
      this.$nextTick(()=>{
        this.current = index;
        this.category =this.dictList.children[this.current].id;
        this.getActivityJiCaiList();
        this.$set(data,'show',true)
      })
    },
    mouseLeave(data){
     this.$set(data,'show',false)
    },
    //分页
    pageChange(item) {
      this.listQuery["curPage"] = item.page;
      this.listQuery["limit"] = item.limit;
      this.getActivityJiCaiList();
    },
    getMate(){
      var metas = document.getElementsByTagName("meta");
      // metas[0].name ="keyword"
      // metas[0].content= data[0].seokeywords
      // metas[1].name ="description"
      // metas[1].content= data[0].seodescription
      document.getElementsByTagName("title")[0].innerText= this.$route.meta.title +'_智污邦环保服务平台';
    },
  },
};
</script>
<style scoped lang='less'>
.active_bater{
  display: flex;
  justify-content:space-between;
  flex-wrap: wrap;
}
.active_bater::after{
  content: '';
  width: 345px;
}
.mt-20 {
  margin-top: 20px;
}
.ml-30 {
  margin-left: 30px;
}
.ml-20 {
  margin-left: 20px;
}
.mb-100 {
  margin-bottom: 100px;
}
.strip {
  font-family: Microsoft YaHei;
  font-weight: 400;
}
.strip p:first-child {
  font-size: 16px;
  color: #333333;
}
.strip p {
  cursor: pointer;
  font-size: 14px;
  color: #999999;
}
.actives {
  width: 82px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  background: #3bae30;
  border-radius: 3px;
  color: white !important;
}
.cont_list {
  width: 32%;
  cursor: pointer;
  margin-bottom: 20px;
}
.cont_midel {
  width: 100%;
  height: 228px;
  position: relative;
  display: flex;
  align-items: center;
}
.cont_midel_img{
  overflow: hidden;
  width: 100%;
  height: 200px;
}
.cont_midel_img img{
  width: 100%;
  height: 100%;
  transition: all 0.6s;
}
.cont_midel img:hover{
   cursor: pointer;
   transform: scale(1.2);
}
.midel_fetr {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ffffff;
  text-align: center;
}
.midel_fetr p:nth-child(1) {
  font-size: 22px;
}
.midel_fetr p:nth-child(2) {
  font-size: 14px;
  margin-top: 15px;
}
.midel_title {
  height: 56px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 28px;
  height: 60px;
}
.midel_text {
  margin-top: 10px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  padding-bottom: 20px;
}
.el-pagination {
  margin-top: 40px;
  margin-left: 80px;
}

.news_item_nav {
  line-height: 62px;
  background: url("../../assets/images/bg_8.jpg") no-repeat center/cover;
  ul {
    display: flex;
    padding: 0 30px;
    li {
      transition: all 0.5s;
      cursor: pointer;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      margin-right: 24px;
      &:last-of-type {
        margin-right: 0;
      }
    }
    .active {
      position: relative;
      &::after {
        position: absolute;
        bottom: 10px;
        left: 0;
        display: inline-block;
        content: "";
        width: 100%;
        height: 2px;
        background: #ffffff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/other/jicai_activity_list.vue